import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import OtpInput from 'react-otp-input';
import { api } from 'src/Api';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import BackButton from 'src/components/BackButton';
import { toast } from 'react-toastify';
import palette from 'src/theme/palette';

// ----------------------------------------------------------------------//

export default function OtpForm() {
  const location = useLocation();
  const { user, token } = location.state || {};
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [loading, setloading] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(60);
  const [resendotp, setresendotp] = useState(false);

  const email = localStorage.getItem('email');

  const otpContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px'
  };

  const otpInputStyle = {
    width: '50px',
    height: '50px',
    fontSize: '20px',
    textAlign: 'center',
    border: '1.5px solid #ccc',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.3s',
    fontFamily: 'poppinsRegular'
  };

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : `${time}`;
  };

  function VerifyCode() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        email: email,
        otp: otp
      }),
      redirect: 'follow'
    };

    setloading(true);

    fetch(api.otp_verify, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json().then((error) => {
            toast.error(error?.error);
          });
        }
      })
      .then((result) => {
        if (result) {
          toast.success(result.message);
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          navigate('/dashboard', { replace: true });
        }
      })
      .catch((error) => {
        toast.error(error.message);
        console.log('error', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  const handleResend = () => {
    setMinutes(0);
    setSeconds(60);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const ResendOTP = () => {
    setresendotp(true);
    var formdata = new FormData();

    formdata.append('email', email);
    formdata.append('type', 'register');

    var requestOptions = {
      method: 'POST',
      body: formdata
    };

    fetch(api.resend_otp, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          handleResend();
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        toast.error('An error occurred.');
      })
      .finally(() => {
        setresendotp(false);
      });
  };

  return (
    <Stack
      sx={{
        backgroundColor: '#fff',
        borderRadius: '15px',
        paddingX: 5,
        paddingTop: 3,
        paddingBottom: 6,
        boxShadow: palette.primary.mainShadow,
        border: `1.5px solid ${process.env.REACT_APP_PRIMARY}`
      }}
    >
      <BackButton />

      <div style={otpContainerStyle}>
        <OtpInput
          value={otp}
          inputType="number"
          onChange={setOtp}
          numInputs={5}
          renderSeparator={<span>&nbsp;</span>}
          renderInput={(props) => <input {...props} style={otpInputStyle} />}
        />
      </div>

      <LoadingButtonWrapper
        onClick={() => {
          VerifyCode();
        }}
        loading={loading}
        disabled={otp.length < 5 || resendotp}
        title="Continue"
      />

      <LoadingButtonWrapper
        style={{ marginTop: 10 }}
        onClick={() => {
          if (seconds == 0) {
            ResendOTP();
          }
        }}
        loading={resendotp}
        disabled={seconds > 0}
        title={seconds > 0 ? `\t ${formatTime(minutes)}:${formatTime(seconds)}` : <>Resend OTP</>}
      />
    </Stack>
  );
}
